export const STAGES = [
  "Discovery Call",
  "Goal Mapping & Risk Profiling",
  "Written Plan",
  "Execution",
  "Ongoing Review",
];

export const stageIndex = (s) => Math.max(0, STAGES.indexOf(s));
export const stageChipClass = (s) => `stage-chip stage-${stageIndex(s) + 1}`;

export const ADVICE_CATEGORIES = [
  "Emergency Fund",
  "Health Insurance",
  "Term Insurance",
  "Debt Management",
  "Surplus Investment Strategy",
  "Retirement & SWP",
];

export const LIFE_EVENTS = [
  "New Child",
  "Job Change",
  "New Loan",
  "Health Event",
  "Other",
];

export const formatINR = (n) => {
  if (n == null || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);
};

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return iso; }
};

export const roleLabel = (r) => ({
  Admin: "Principal Advisor",
  Advisor: "Senior Advisor",
  Execution: "Execution",
  ServiceRep: "Service Rep",
}[r] || r);
